/**
 * @desc 页面banner消息
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** channel */
  channel?: number;
  /** province */
  province?: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.HttpResponse>(`/storeapi/api/v3/page/banners`, {
    params,
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.HttpResponse;
export default req;
